import { Button } from '@/components/ui/button';
import { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

interface ActionButtonProps {
  icon: LucideIcon;
  variant?: 'edit' | 'delete' | 'secondary';
  onClick?: (e: React.MouseEvent) => void;
}

const variantStyles = {
  edit: {
    base: 'bg-blue-100 hover:bg-blue-200 border-blue-300',
    icon: 'text-blue-700',
  },
  delete: {
    base: 'bg-rose-100 hover:bg-rose-200 border-rose-300',
    icon: 'text-rose-700',
  },
  secondary: {
    base: 'bg-violet-100 hover:bg-violet-200 border-violet-300',
    icon: 'text-violet-700',
  },
};

export function ActionButton({ icon: Icon, variant = 'secondary', onClick }: ActionButtonProps) {
  const styles = variantStyles[variant];

  return (
    <Button
      type="button"
      variant="outline"
      size="icon"
      className={cn(
        'border-2 transition-all duration-200 shadow-sm hover:shadow',
        styles.base
      )}
      onClick={onClick}
    >
      <Icon className={cn('h-4 w-4', styles.icon)} />
    </Button>
  );
}